export default __webpack_public_path__ + "static/media/TransportationSpaceships_03.d3afa608.png";